import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import FlagstoneTheme from '../../config/flagstoneTheme';

export default function ActionButton(props) {

    const classes = useStyles();

    return (
        <button className={classes.actionButton} disabled={props.disabled} onClick={() => props.action()}>{props.text}</button>
    );
}


const useStyles = makeStyles(() => ({
    actionButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        margin: "10px",
        color: "white",
        height: "30px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        fontWeight: "bold",
        fontFamily: "Lato, sans-serif",

    }

}));
